import React from "react";
import { withFormik, Form } from "formik";
import * as Yup from "yup";
import { FormGroup, Button } from "reactstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { toast } from "react-toastify";
import axios from "../../services/api/api";
import { API_BASE_URL } from "../../constants/api.constants";
import Select from "react-select";
import { TOAST_CONFIG } from "../../Utilities/toastConfig";
import { formatServiceError } from "../../Utilities/serviceErrorHelper";

const CreateProgrammeForm = (props) => {
  const intl = useIntl();
  const { values, errors, touched, isSubmitting, dismissModal } = props;

  const handleChange = (selected) => {
    values.selectedProgram = selected;
  };

  return (
    <div className="col-12 col-sm-12">
      <Form>
        <FormGroup>
          <Select
            placeholder={intl.formatMessage({ id: "ChooseProgram" })}
            className={errors.name && touched.name ? "is-invalid" : ""}
            noOptionsMessage={() => intl.formatMessage({ id: "NoProgramsToChoose" })}
            name="name"
            onChange={(selected) => handleChange(selected)}
            options={values.fortNoxPrograms.map((option) => ({
              ...option,
              label: option.programName,
              value: option.costCenter,
              clearableValue: true,
            }))}
          />
          {errors.name && touched.name && (
            <div className="invalid-feedback">{errors.name}</div>
          )}
        </FormGroup>

        <div className="d-flex justify-content-end gap-2">
          <Button
            color="secondary"
            outline
            type="button"
            onClick={dismissModal}
          >
            <FormattedMessage id="Cancel" />
          </Button>
          <Button color="primary" outline type="submit" disabled={isSubmitting}>
            <FormattedMessage id={isSubmitting ? "Wait" : "Add"} />
          </Button>
        </div>
      </Form>
    </div>
  );
};

const FormikForm = withFormik({
  mapPropsToValues: (props) => {
    return {
      name: props.name || "",
      fortNoxPrograms: props.fortNoxPrograms,
      selectedProgram: null,
    };
  },

  validationSchema: Yup.object().shape({
    selectedProgram: Yup.mixed().required(
      <FormattedMessage id="MustSelectProgram" />
    ),
  }),

  handleSubmit(values, { props, resetForm, setErrors, setSubmitting }) {
    axios
      .post(`${API_BASE_URL}/programme`, {
        name: values.selectedProgram.programName,
        customer: props.school,
        costCenter: values.selectedProgram.fortNoxCostCenter,
      })
      .then((response) => {
        toast.success(
          <FormattedMessage id="Tostify.Message.AddedProgram" />,
          TOAST_CONFIG
        );
        props.refreshProgrammes();
        resetForm();
      })
      .catch((err) => {
        toast.error(
          formatServiceError(props.intl, err?.response?.data),
          TOAST_CONFIG,
        );
      })
      .finally(() => setSubmitting(false));
  },
})(CreateProgrammeForm);

const CreateProgrammeFormWithIntl = (props) => {
  const intl = useIntl();

  return <FormikForm {...props} intl={intl} />;
};

export default CreateProgrammeFormWithIntl;
